import { render } from "./FebVegas.vue?vue&type=template&id=06b75c4b"
import script from "./FebVegas.vue?vue&type=script&lang=js"
export * from "./FebVegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__